import { DEPLOYMENT_ID_COOKIE_NAME } from '@layers/web/constants/skew-protection.ts'

// Reload with cache-busting query param
const reload = () => {
  const url = new URL(window.location.href)
  url.searchParams.set('cb', Math.round(Math.random() * 100000).toString())
  reloadNuxtApp({ path: `${url.pathname}${url.search}` })
}

export const useSkewProtection = () => {
  const { public: { VERCEL_DEPLOYMENT_ID } } = useRuntimeConfig()

  const checkForSkew = async (): Promise<boolean> => {
    try {
      const response = await fetch('/localapi/deployment-id')

      // If we get a different deployment ID in response headers, we have skew
      const responseDeploymentId = (await response.json()).deploymentId

      return (
        responseDeploymentId &&
        VERCEL_DEPLOYMENT_ID &&
        responseDeploymentId !== VERCEL_DEPLOYMENT_ID
      )
    } catch {
      // If we can't check, assume no skew
      return false
    }
  }

  const clearDeploymentIdCookie = () => {
    document.cookie = `${DEPLOYMENT_ID_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/_nuxt`
  }

  const reloadToLatestDeployment = () => {
    clearDeploymentIdCookie()
    window.caches.keys()
      .then(keys => Promise.all(keys.map(key => caches.delete(key))))
      .finally(() => reload())
  }

  return {
    clearDeploymentIdCookie,
    checkForSkew,
    reloadToLatestDeployment,
  }
}